module.exports = __webpack_public_path__ + "static/media/doc.8c5dbc51.png";